import api from './axiosConfig.js'

export const payrollApi = {
  // Generate payroll for a specific employee for a given month and year
  generatePayroll: (data) => {
    const orgId = localStorage.getItem('org_id')
    return api.post('/payroll/generate', data, {
      headers: orgId ? { 'X-Org-ID': orgId } : {}
    })
  },

  // Get list of payrolls (with pagination, month, year filters)
  getPayrollList: (params = {}) => {
    const orgId = localStorage.getItem('org_id')
    return api.get('/payroll/list', {
      params,
      headers: orgId ? { 'X-Org-ID': orgId } : {},
      skipErrorToast: true
    })
  },

  // Get payroll history for a specific employee
  getEmployeePayrollHistory: (params = {}) => {
    const orgId = localStorage.getItem('org_id')
    return api.get('/payroll/employee/get-payroll-history', {
      params,
      headers: orgId ? { 'X-Org-ID': orgId } : {},
      skipErrorToast: true
    })
  },

  // Get summary metrics for payroll dashboard
  getPayrollSummary: (params = {}) => {
    const orgId = localStorage.getItem('org_id')
    return api.get('/payroll/summary', {
      params,
      headers: orgId ? { 'X-Org-ID': orgId } : {},
      skipErrorToast: true
    })
  },

  // Get specific payslip details by payroll_id
  getPayslip: (params = {}) => {
    const orgId = localStorage.getItem('org_id')
    return api.get('/payroll/payslip/get-payroll', {
      params,
      headers: orgId ? { 'X-Org-ID': orgId } : {}
    })
  }
}
